import { VersionEvent } from '../types';
const hiddenKeys = [
    'status',
    'status_code',
    'status_icon',
    'status_color',
    'frequency_id',
    'work_order_status',
    'work_order_status_id',
    'work_order_status_icon',
    'work_order_status_color',
    'inspection_type_id',
    'default_sales_person_id',
    'work_order_type_id',
    'uuid',
    'default_service_tech_id',
    'default_subcontractor_id',
    'default_tech_id',
    'tax_item_id',
    'price_list_id',
    'account_id',
    'territory_id',
    'deficiency_resolution_status_id',
    'sprinklers_code_year',
    'fire_doors_code_year',
    'fire_alarms_code_year',
    'fire_alarms_verification_code_year',
    'fire_exit_signs_code_year',
    'fire_extinguishers_code_year'
];
export default function getVersionDetails(activity) {
    if ('notes' in activity) {
        return [];
    }
    const version = activity;
    const details = Object.entries(version.changes)
        .map(([key, [oldValue, newValue]]) => {
        return { key, oldValue, newValue };
    })
        .filter(({ key, oldValue, newValue }) => !hiddenKeys.includes(key) && (newValue || version.event !== VersionEvent.Create) && (!!oldValue || !!newValue));
    return details;
}
